/*
Important
This file is used only for the vue3 application.
Changes made here will not be reflected in the Vue3 application.
You need to make changes in the vue2 file also
Vue2 file: wwwroot\js\WebsitePrimary\components\VehicleCount\VehicleCount.js
Any clarifications contact Laxman Directly
*/
import axios from 'axios';
import ShiftDigitalService from '../../Events/ShiftDigital/ShiftDigitalService';
import { TagManagerContainer } from '../../Events/GoogleTagManager/TagManagerContainer';

import CommonUtility, { clearHeightByElement } from '../../../../js/services/CommonUtility';
import {
  fireCTAClickEvents,
  onCommonLinkLogs,
} from '../../Events/TagManagerServices/TaggingEventForPages';
import ShiftDigitalContainer from '../../Events/ShiftDigital/ShiftDigitalContainer';
import { SHIFT_DIGITAL_VEHICLE_COUNT_CAROUSEL_ASSET_NAME } from '../../../../js/services/ShiftDigital/ShiftDigitalConstants';
import { useThousandseperator } from '../../Composables/Thousandseperator/Thousandseperator';
import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import ResizeHandler from '../../../../js/services/commonResizeEvents';

export default {
  data() {
    return {
      imageWidth: 350,
      imageHeight: 262,
      useSellingPriceOnInventoryControl: window.useSellingPriceOnInventoryControl,
      vehicleCountCurrentSlide: 0,
      useoverrides: window.digiServiceUseOverrides,
      useMSRPInsteadofFinalPriceforStartingAt: window.useMSRPInsteadofFinalPriceforStartingAt,
      themeName: window.themeName,
      shiftDigital: '',
      inventoryVehicledetails: '',
      resizeHandler: '',
      slickOptions: {
        infinite: true,
        slidesPerGroup: 1,
        groupsToShow: 1,
        groupsToScroll: 1,
        dots: false,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              groupsToShow: window.isFdDealer ? 4 : 6,
              groupsToScroll: window.isFdDealer ? 4 : 6,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              groupsToShow: 5,
              groupsToScroll: 5,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 991,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
            },
          },
        ],
        nextArrow: `<em class="primaryicon-right-arrow bgcolor-primary _msbi_background_color" style="color:#cccccc;cursor:pointer;z-index:1"></em>`,
        prevArrow: `<em class="primaryicon-left-arrow" style="cursor:pointer;z-index:1"></em>`,
      },
      LuxurySlickOptions: {
        infinite: true,
        groupsToShow: 1,
        groupsToScroll: 1,
        dots: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 3,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
            },
          },
        ],
        nextArrow: `<em class="primaryicon-right-arrow bgcolor-primary _msbi_background_color" style="color:#cccccc;cursor:pointer;z-index:1"></em>`,
        prevArrow: `<em class="primaryicon-left-arrow" style="cursor:pointer;z-index:1"></em>`,
      },
      enableCountOnPrimaryControl: true,
      isSimplifyTemplate: window.masterLayoutName.toLowerCase() === '_website_simplify',
      filterByIdValue: '', //initial vehicletypeid
      filterByVehicleId: false,
      showLoading: false,
      isGroupByModel: true,
      showCallForPriceSRP: window.showCallForPriceSRP,
      salesnumber: window.salesNumber,
      isMobile: window.ismobile,
      setMatchHeightData: {
        el: ['.inventory-vehicle-block.no-hover', '.inventory-image'],
      },
      currentDesign: '',
      showBMWSlick: true,
      showArrows: true,
      slickDirection: 'next',
    };
  },
  props: {
    heading: {
      default: '',
      required: false,
    },
    subHeading: {
      default: '',
      required: false,
    },
    enableVehicleCount: {
      default: '',
      required: false,
    },
    hidePricing: {
      type: Boolean,
      default: false,
      required: false,
    },
    inventoryCountLabel: {
      default: '',
      required: false,
    },
    inventorySort: {
      default: '',
      required: false,
    },
    filterModels: {
      type: Array,
      default: () => [],
      required: false,
    },
    vdpNavigation: {
      default: false,
      type: Boolean,
      required: false,
    },
    vehicleType: {
      default: '',
      required: false,
    },
    groupByModel: {
      default: false,
      required: false,
    },
  },
  components: {
    VSlickCarousel,
  },
  computed: {
    getHeading() {
      return this.heading ? this.heading : "Today's Vehicle Inventory";
    },
    getSubHeading() {
      return this.subHeading ? this.subHeading : 'View All Inventory';
    },
  },
  methods: {
    logTagLinkClickEvents(vehicle) {
      let label = `${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`;
      let url = vehicle.vehicles.url;
      let tagManager = TagManagerContainer.getDealerObject();
      if (tagManager && typeof tagManager.getLinkClickEvent === 'function') {
        tagManager.getLinkClickEvent(label, url);
      }
      fireCTAClickEvents(
        `${vehicle.vehicles.year} ${vehicle.vehicles.model} ${vehicle.vehicles.trim}`,
        { skipLink: true, vin: vehicle.vehicles.vin }
      );
      onCommonLinkLogs({ label, url });
    },
    onCommonLinkLogs(label, url) {
      onCommonLinkLogs({ label, url });
    },
    handleAfterChange(event, slick, currentSlide) {
      this.vehicleCountCurrentSlide = currentSlide;
      if (this.shiftDigital) {
        let carouselClick = {
          assetPosition: currentSlide,
          assetName: SHIFT_DIGITAL_VEHICLE_COUNT_CAROUSEL_ASSET_NAME,
        };
        ShiftDigitalService.shiftDigitalCarouselClick(this.shiftDigital, carouselClick);
      }
    },
    shouldIncludeModel(newModel) {
      const lastYear = new Date().getFullYear() - 1;
      if (this.filterModels && newModel.vehicles.model && newModel.vehicles.year > lastYear) {
        return this.filterModels.includes(newModel.vehicles.model.toLowerCase());
      }
      return false;
    },
    vechilesVDP(vehicle) {
      this.logTagLinkClickEvents(vehicle);
      if (this.vdpNavigation) {
        window.location.href = `/viewdetails/${vehicle.vehicles.vin}/`;
      } else {
        window.location.href = vehicle.vehicles.url;
      }
    },
    getVehicles() {
      let inventorySortBy = this.inventorySort ? this.inventorySort : window.sRPSortType;
      let urlString = `${window.ApiBaseUrl}/Inventory/newmodelsBanners?accountId=${
        window.accountId
      }&campaignId=${
        window.campaignId
      }&themeName=${window.themeName.toLowerCase()}&sRPSortType=${inventorySortBy}&enableCountsOnInventoryControl=${
        window.enableCountsOnInventoryControl
      }&type=${this.vehicleType}&primaryInventoryVehiclesGroupbyModel=${this.groupByModel}`;
      let parameters = new URLSearchParams(window.location.search);
      if (parameters.has('fetchdatafrom')) {
        let queryparamvalue = parameters.get('fetchdatafrom');
        urlString = urlString + '&fetchdatafrom=' + queryparamvalue;
      }
      //add vehicletypeid to filter the vehicles
      if (this.filterByVehicleId) {
        urlString = `${window.ApiBaseUrl}/Inventory/newmodelsBannersByVehicleTypes?accountId=${window.accountId}&campaignId=${window.campaignId}&enableCountsOnInventoryControl=${window.enableCountsOnInventoryControl}
   &vehicleTypeIds=${this.filterByIdValue}&isGroupingModelYear=${this.isGroupByModel}`;

        this.showLoading = true;
      }
      axios
        .get(urlString)
        .then((response) => {
          if (response?.data?.newModels?.length < 3) {
            if (this.currentDesign === 'MitsubishiOemVehicleCount') {
              this.slickOptions.centerMode = false;
            }
          }
          let responseData = [];

          for (let newModel of response.data.newModels) {
            if (newModel.vehicles) {
              if (this.filterModels?.length) {
                if (this.shouldIncludeModel(newModel)) {
                  responseData.push(newModel);
                }
              } else {
                responseData.push(newModel);
              }
            }
          }
          this.inventoryVehicledetails = response.data;
          this.$emit('vehiclecount', this.inventoryVehicledetails.totalVehicleCount);
          if (window.themeName?.toLowerCase() === 'bmw' && responseData?.length) {
            this.inventoryVehicledetails.newModels = responseData.sort((a, b) =>
              a.vehicles?.model.localeCompare(b.vehicles?.model, undefined, { numeric: true })
            );
          } else {
            this.inventoryVehicledetails.newModels = responseData;
          }
          if (this.filterByVehicleId && this.inventoryVehicledetails.newModels.length) {
            this.reInit();
          }
          this.showLoading = false;
          if (window.ismobile && !this.inventoryVehicledetails.newModels?.length) {
            clearHeightByElement('primary-vehicle-inventory');
          }
        })
        .catch((err) => {
          if (window.ismobile) {
            clearHeightByElement('primary-vehicle-inventory');
          }
          this.showLoading = false;
        });
    },

    //used for reinitilize with the vehiclefilterdata
    filterVehicles(vehicleTypeId) {
      this.filterByIdValue = vehicleTypeId;
      this.getVehicles();
    },
    reInit() {
      if (this.showBMWSlick) {
        this.showBMWSlick = false;
        this.$nextTick(() => {
          this.showBMWSlick = true;
        });
      }
      setTimeout(() => {
        this.showArrows = this.$refs.vehicletypeidscountslick.canGoNext;
        document.dispatchEvent(new CustomEvent('matchheight', this.setMatchHeightData));
      }, 100);
    },
    getDefaultValues(url) {
      return CommonUtility.getVehicleGenericColorAngleLogic(url);
    },
    onSubHeadingClick() {
      fireCTAClickEvents(this.getSubHeading, { url: '/inventory' });
    },
    handleBeforeChange(currentSlide, nextSlide) {
      try {
        fireCTAClickEvents(this.slickDirection, {
          skipLink: true,
          carouselClick: {
            interactionLabel: this.slickDirection,
            interactionValue: `${nextSlide === 0 ? 1 : nextSlide} / ${
              this.inventoryVehicledetails?.newModels?.length
            }`,
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
    getThousandSeperator(value) {
      const { Thousandseperator } = useThousandseperator();
      return Thousandseperator(value);
    },
    afterChangeWrapper(...args) {
      try {
        if (typeof this.handleAfterChange === 'function') {
          this.resizeHandler.preventAfterChangeDuringResize(this.handleAfterChange)(...args);
        }
      } catch (error) {
        console.error('Error in afterChangeWrapper method:', error);
      }
    },
  },
  mounted() {
    if (window.ismobile) {
      this.imageHeight = 150;
      this.imageWidth = 280;
    }
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
    this.getVehicles();

    this.enableCountOnPrimaryControl = this.enableVehicleCount === 'True';
    this.resizeHandler = new ResizeHandler();
    this.resizeHandler.addResizeListener();
  },
  beforeDestroy() {
    try {
      this.resizeHandler.removeResizeListener();
    } catch (error) {
      console.error('Error in beforeDestroy lifecycle hook:', error);
    }
  },
};
